import {
  ProductStatus,
  ProductStatusBar,
  ProductStatusProps,
} from '@ui/product/product-status.tsx';
import { Divider, Skeleton } from '@heroui/react';

export type StoreListItemProps = {
  title?: string;
  timesheet?: string;
  statuses?: ProductStatusProps[];
  isLoading?: boolean;
};

export const StoreListItem = ({
  title,
  statuses = [],
  timesheet,
  isLoading = false,
}: StoreListItemProps) => {
  return (
    <div className="flex flex-col gap-3 py-3">
      <Skeleton isLoaded={!isLoading} className="rounded-lg">
        <div className="text-[#222222]">{title}</div>
      </Skeleton>
      <Skeleton isLoaded={!isLoading} className="rounded-lg h-6">
        <ProductStatusBar>
          {statuses?.map((status, index) => (
            <ProductStatus key={index} {...status} />
          ))}
        </ProductStatusBar>
      </Skeleton>
      <Skeleton isLoaded={!isLoading} className="rounded-lg h-6">
        <div className="border rounded-xl p-4 flex flex-row items-center text-sm text-[#60656C] lg:bg-[#F8F9FA] lg:border-none justify-between border-[#EAEAEB]">
          <p>Время работы</p>
          <p>{timesheet}</p>
        </div>
      </Skeleton>
    </div>
  );
};

export type StoresListProps = {
  items?: (StoreListItemProps | undefined)[];
  isDivided?: boolean;
};

export const StoresList = ({
  isDivided = true,
  items = [],
}: StoresListProps) => {
  return (
    <>
      {items?.map((item, index) => (
        <div key={index}>
          <StoreListItem {...item} />
          {isDivided && index + 1 !== items?.length && <Divider />}
        </div>
      ))}
    </>
  );
};
